function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStormstrock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 357.3 320",
    style: {
      enableBackground: "new 0 0 357.3 320"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M135.3,141.3c0-11.2-0.2-22.4,0.1-33.5c0.2-7.6,4.9-11.5,12-11.1c6.8,0.3,10.8,4.6,10.8,11.9 c0.1,17.5,0.1,35.1,0,52.6c0,4.6,1.4,8,5.1,10.8c10.8,8,21.7,16.1,32.3,24.4c2.7,2.1,5.4,5,6.6,8.1c1.8,4.7-0.1,9.2-4,12.5 c-3.8,3.3-8.3,3.1-12.2,0.9c-5.2-3-10.1-6.6-15-10.2c-10.1-7.5-20-15.2-30.1-22.7c-3.8-2.8-5.8-6.3-5.8-11 C135.2,163,135.2,152.1,135.3,141.3L135.3,141.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M354.1,77.1c-0.1-24.8-10-45-29.6-60.3c-9-7.1-19.1-12.1-30.7-13.7c-6.3-0.9-10,1.5-11.4,7.4 c-1.3,5.2,0.9,9.2,6.3,11.3c1.7,0.7,3.5,1.1,5.3,1.7c21.4,6.8,34.3,21.4,39.4,43.1c2.7,11.3,0.3,22.1-3.2,32.9 c-1.7,5.3,0.7,10.4,5.1,12c5.5,2,10.3,0.3,12.8-4.9C352.6,97.2,354.4,87.4,354.1,77.1z M304,44.9c-7.3-7.2-16-11.9-26.3-12.8 c-7.8-0.7-12.3,4.9-10.5,12.4c1,4.2,4,5.9,7.9,7c19.9,5.7,29,22.9,22.9,42.7c-0.5,1.7-0.7,3.7-0.7,5.5c0.1,4.4,2.5,7.4,6.7,8.4 c4.3,1,8.3,0.8,10.9-3.8c4.1-7.1,4.9-14.9,5.3-22.6C319.7,67,314.1,54.9,304,44.9z M151.4,30.2C81.8,26.3,9.6,80,3.6,162.9 c-5.7,78.9,51.7,149.1,136,154c74.5,4.3,145.1-51.1,150.7-135.9C295,109.4,238.8,32.6,151.4,30.2z M146.2,293.5 c-65.8-0.2-119.9-54.6-119.6-120.1c0.3-66.9,54.7-121,122-120c65,1,118.7,54.1,118,121.5C266.5,240.1,211.9,293.8,146.2,293.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStormstrock);
export default __webpack_public_path__ + "static/media/storm strock.148a9973f4a4c21bcbc1a4d30f4217f6.svg";
export { ForwardRef as ReactComponent };